__turbopack_context__.v({
  "layout": "Layout-module-scss-module__G4sWQq__layout",
});
